import HomePage from "../components/home-page/home-page.component";
import MediaBar from "../components/social-media-bar/social-media-bar.component";

const Home = () => (
    <>
        <HomePage />
    </>
)

export default Home;